<template>
	<v-app>
		<div class="loader" v-if="$myStore.state.loaderCount > 0">
			<v-progress-circular
					:size="50"
					color="primary"
					indeterminate
			></v-progress-circular>
		</div>

		<v-dialog class="dialog-html" max-width="772" v-model="htmlModal.show">
			<v-card>
				<v-card-text v-html="htmlModal.text">
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="htmlModal.show = false" color="success">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" v-model="alertModal.show">
			<v-card>
				<v-card-text class="black--text text--lighten-3" v-html="alertModal.text">
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="alertModal.show = false">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" persistent v-model="verifyModal.show">
			<v-card class="pa-4">
				<v-card-text class="black--text text--lighten-3" v-html="verifyModal.text">
				</v-card-text>
				<v-card-actions>
					<v-btn @click="verifyModal.result(false)" color="danger" dark>{{ $t('buttons.no') }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="verifyModal.result(true)">{{ $t('buttons.yes') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" persistent v-model="promptModal.show">
			<v-card class="pa-4">
				<v-card-text class="black--text text--lighten-3">
					<InputField :label="promptModal.text"
								v-model="promptModal.value"></InputField>
				</v-card-text>
				<v-card-actions>
					<v-btn @click="promptModal.result(false)" color="danger" dark>{{ $t('buttons.cancel') }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="promptModal.result(true)">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="680" persistent v-model="dropdownModal.show">
			<v-card class="pa-4">
				<v-card-text class="black--text text--lighten-3">
					<Dropdown
							:ajax="true"
							:data="dropdownModal.endpoint"
							:label="dropdownModal.text"
							v-if="dropdownModal.endpoint!=null"
							v-model="dropdownModal.value"></Dropdown>
				</v-card-text>
				<v-card-actions>
					<v-btn @click="dropdownModal.result(false)" color="danger" dark>{{ $t('buttons.cancel') }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="dropdownModal.result(true)">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog max-width="480" persistent v-model="dateModal.show">
			<v-card class="pa-4">
				<v-card-text class="black--text text--lighten-3">
					<v-flex class="black--text title mb-3" xs12>
						{{dateModal.title}}
					</v-flex>
					<DatePicker :clearable="true"  :date-label="dateModal.text" class="no-pa"
								v-model="dateModal.value"></DatePicker>
				</v-card-text>
				<v-card-actions>
					<v-btn @click="dateModal.result(false)" color="danger" dark>{{ $t('buttons.cancel') }}
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn @click="dateModal.result(true)">{{ $t('buttons.ok') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-snackbar :timeout="3000" :top="true" class="notification text-xs-center" color="primary"
					v-model="notification.show">{{ notification.text }}
		</v-snackbar>

		<router-view></router-view>
	</v-app>
</template>

<script>
	import InputField from "./components/trinkets/InputField";
	import Dropdown from "./components/trinkets/Dropdown";
	import DatePicker from "./components/trinkets/DatePicker";

	export default {
		name: 'App',
		components: {DatePicker, InputField, Dropdown},
		data() {
			return {
				alertModal: {
					show: false,
					text: ''
				},
				verifyModal: {
					show: false,
					text: '',
					result: (result) => {
						this.verifyModal.show = false;
						this.verifyModal.reaction(result);
					},
					reaction: () => {
					}
				},
				promptModal: {
					show: false,
					text: '',
					value: '',
					result: (result) => {
						this.promptModal.show = false;
						if (result !== false) {
							this.promptModal.reaction(this.promptModal.value);
						} else {
							this.promptModal.reaction(false);
						}
					},
					reaction: () => {
					}
				},
				dateModal: {
					title: '',
					show: false,
					text: '',
					error: '',
					value: null,
					result: (result) => {
						if ((this.dateModal.value != null) || (result === false)) {
							this.dateModal.show = false;
							if (result !== false) {
								this.dateModal.reaction(this.dateModal.value);
							} else {
								this.dateModal.reaction(false);
							}
						}
					},
					reaction: () => {
					}
				},
				dropdownModal: {
					show: false,
					text: '',
					value: '',
					endpoint: null,
					result: (result) => {
						this.dropdownModal.show = false;
						if (result !== false) {
							this.dropdownModal.reaction(this.dropdownModal.value);
						} else {
							this.dropdownModal.reaction(false);
						}
					},
					reaction: () => {
					}
				},
				htmlModal: {
					show: false,
					text: ''
				},
				notification: {
					show: false,
					text: ''
				}
			}
		},
		computed: {},
		methods: {
		},
		mounted() {
			let vm = this;
			this.$modalBus.$on('ALERT', message => {
				vm.alertModal.text = message;
				vm.alertModal.show = true;
			});
			this.$modalBus.$on('VERIFY', data => {
				vm.verifyModal.text = data.message;
				vm.verifyModal.reaction = data.response;
				vm.verifyModal.show = true;
			});
			this.$modalBus.$on('PROMPT', data => {
				vm.promptModal.text = data.message;
				vm.promptModal.value = data.initial;
				vm.promptModal.reaction = data.response;
				vm.promptModal.show = true;
			});
			this.$modalBus.$on('DATE', data => {
				vm.dateModal.text = data.message;
				vm.dateModal.title = data.title;
				vm.dateModal.value = data.initial;
				vm.dateModal.reaction = data.response;
				vm.dateModal.show = true;
			});
			this.$modalBus.$on('DROPDOWN', data => {
				vm.dropdownModal.text = data.message;
				vm.dropdownModal.value = data.initial;
				vm.dropdownModal.reaction = data.response;
				vm.dropdownModal.endpoint = null;
				vm.$nextTick(() => {
					vm.dropdownModal.endpoint = data.endpoint;
				});
				vm.dropdownModal.show = true;
			});
			this.$modalBus.$on('NOTIFY', message => {
				vm.notification.text = message;
				vm.notification.show = true;
			});
			this.$modalBus.$on('ALERT_HTML', message => {
				vm.htmlModal.text = message;
				vm.htmlModal.show = true;
			});

			this.$APICall('get', 'version', {}, (data, success) => {
				if (success) {
					if (data.version != vm.$getCookie('ide3_version')) {
						vm.$setCookie('ide3_version', data.version);
						window.location.reload(true);
					}
				}
			});
		}
	}
</script>

<style scoped>
	.notification {
		z-index: 999999;
	}

	.loader {
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 999;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.3);
		font-size: 100px;
		text-align: center;
		padding-top: 100px;
	}

	>>> .cursor-pointer {
		cursor: pointer;
	}

	>>> .bottom-buttons-outer {
		position: fixed;
		bottom: 0px;
		left: 0px;
		width: 100%;
		height: 50px;
		z-index: 9999999999;
		background-color: #EFEFEF;
		text-align: center;
		-webkit-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
		-moz-box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
		box-shadow: 0px -1px 5px -1px rgba(163, 163, 163, 1);
	}

	>>> .v-navigation-drawer {
		background-color: #1E2933;
	}

	>>> .background-transparent {
		background: transparent !important;
	}

	>>> .v-btn {
		box-shadow: none !important;
		border-radius: 8px !important;
	}

	>>> .module-title {
		font-weight: bold;
		font-size: 20px;
		color: #757575;
		border-bottom: 1px solid #949494;
	}

	/deep/ .dialog-html .v-card__text {
		text-align: justify;
		padding-left: 60px;
		padding-top: 60px;
		padding-right: 60px;
		color: #707070 !important;
	}

	>>> .main-menu .v-list__tile {
		padding: 0px !important;
		padding-left: 10px !important;
	}

	>>> .main-menu .v-list__tile__action {
		width: 20px !important;
		min-width: 20px !important;
		margin-right: 5px !important;
	}

	>>> .main-menu .v-list__group__header__prepend-icon {
		padding: 0px !important;
		padding-left: 10px !important;
		width: 20px !important;
		min-width: 20px !important;
		margin-right: 5px !important;
	}

	>>> .v-list__group__items .v-list__tile {
		padding-left: 30px !important;
	}

	>>> textarea {
		scrollbar-color: #6EC276 #E2E2E2;
		scrollbar-width: thin;
	}

	>>> textarea::-webkit-scrollbar {
		width: 7px;
	}

	>>> textarea::-webkit-scrollbar-track {
		background-color: #E2E2E2;
	}

	>>> textarea::-webkit-scrollbar-thumb {
		background-color: #6EC276;
	}

	>>> .no-pa .ma-2 {
		margin: 0px !important;
	}
</style>
